import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import ShareBarBase from './ShareBarBase';

export default class FacebookShare extends ShareBarBase {
  static propTypes = {
    shareBarStyles: PropTypes.object,
    url: PropTypes.string.isRequired,
    additionalURLParams: PropTypes.array
  };
  static defaultProps = {
    additionalURLParams: []
  };

  componentDidMount() {
    super.componentDidMount();
    if (typeof this.window.FB === 'undefined') {
      // Adding the script to the page to embed Facebook Share Button when this widget gets mounted on the DOM
      if (this.window.document.getElementById('facebook-wjs')) {
        return;
      }
      const fbRoot = this.window.document.createElement('fb-root');
      let script = this.window.document.getElementsByTagName('script')[0];
      if (!script || !script.parentNode) {
        return;
      }
      script.parentNode.insertBefore(fbRoot, script);
      const facebookScript = this.window.document.createElement('script');
      facebookScript.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2';
      facebookScript.async = true;
      facebookScript.id = 'facebook-wjs';
      script.parentNode.insertBefore(facebookScript, script);
    } else {
      // Re-loading the Share Button when the widget gets re-mounted with existing button in it
      this.window.FB.XFBML.parse();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.customizeWidgetData && this.props.customizeWidgetData &&
      prevProps.customizeWidgetData.displayFacebook !== this.props.customizeWidgetData.displayFacebook) {
      // Re-loading the button when display property is updated by the user
      if (typeof this.window.FB !== 'undefined') {
        this.window.FB.XFBML.parse();
      }
    }
  }

  render() {
    const {
      shareBarStyles,
      url,
      additionalURLParams
    } = this.props;

    const updatedURL = this.addQueryParamsToURL(url, additionalURLParams);
    const encodedURL = encodeURIComponent(updatedURL);

    return (
      <div
        {...resolve(shareBarStyles, 'wrapper', 'facebookContainer')}>
        <div className="fb-share-button"
          // 'data-href' should be of the format: "https://www.cvent.com/in/"
          data-href={updatedURL}
          data-layout="button"
          size="small"
          data-mobile-iframe="true"
        >
          <a
            target="_blank"
            // 'u' should be of the format: "https%3A%2F%2Fwww.cvent.com%2Fin%2F"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodedURL}&amp;src=sdkpreparse`}
            className="fb-xfbml-parse-ignore">Share</a>
        </div>
      </div>
    );
  }
}
